import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BrandAsset, BrandAssetsState } from "../types/brandAssetsTypes";
import { fetchBrandAssetsThunk } from "../thunks/brandAssetsThunk";

const initialState: BrandAssetsState = {
  assets: [],
  isLoading: false,
  error: null,
};

export const brandAssetsSlice = createSlice({
  name: "brandAssets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBrandAssetsThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      fetchBrandAssetsThunk.fulfilled,
      (state, action: PayloadAction<BrandAsset[]>) => {
        state.isLoading = false;
        state.assets = action.payload;
      },
    );
    builder.addCase(fetchBrandAssetsThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = (action.payload as string) || "An unknown error occurred.";
    });
  },
});

export default brandAssetsSlice.reducer;
